const { Entity } = require('./entity')

class JournalEntry extends Entity {
  constructor (quickbooks) {
    super(quickbooks, 'JournalEntry')
  }
}

module.exports = { JournalEntry }
